import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import tf from '../../img/CompositeMesh/tt2.png'

function AdvantagesOfCompositeMesh () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto relative">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("compositemesh.add.1")}</Trans>
                    </p>
                </div>
                <div className='flex flex-col xl:flex-row justify-between items-end mt-[30px] xl:mt-[70px] relative'>
                    <div className='xl:max-w-[312px] xl:hidden open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px] flex flex-col gap-[20px] xl:gap-[60px]'>
                        <img src={tf} alt="" className='xl:absolute mt-[20px] xl:mt-0 top-0 left-1/2 xl:-translate-x-1/2'/>
                        <p>• {t('compositemesh.add.10')}</p>
                    </div>
                    <div className='xl:max-w-[312px] open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px] flex flex-col gap-[20px] xl:gap-[60px]'>
                        <p>• {t('compositemesh.add.2')}</p>
                        <p>• {t('compositemesh.add.3')}</p>
                        <p>• {t('compositemesh.add.4')}</p>
                        <p>• {t('compositemesh.add.5')}</p>
                    </div>
                    <div className='xl:max-w-[312px] hidden open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px] xl:flex flex-col gap-[20px] xl:gap-[60px]'>
                        <img src={tf} alt="" className='xl:absolute mt-[20px] xl:mt-0 top-0 left-1/2 xl:-translate-x-1/2'/>
                        <p>• {t('compositemesh.add.10')}</p>
                    </div>
                    <div className='xl:max-w-[312px] open-sans text-[#F6F6F6] font-[300] text-[14px] xl:text-[16px] flex flex-col gap-[20px] xl:gap-[60px]'>
                        <p>• {t('compositemesh.add.6')}</p>
                        <p>• {t('compositemesh.add.7')}</p>
                        <p>• {t('compositemesh.add.8')}</p>
                        <p>• {t('compositemesh.add.9')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdvantagesOfCompositeMesh;